/* import __COLOCATED_TEMPLATE__ from './sub-dropdown.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();